import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Car, SignIn, CircleNotch } from '@phosphor-icons/react';
import { toast } from 'sonner';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ProLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) { toast.error('Remplissez tous les champs'); return; }
    setLoading(true);
    try {
      const resp = await axios.post(`${API_URL}/api/pro/auth/login`, { email, password });
      const { access_token, user } = resp.data;
      login(access_token, user);
      toast.success(`Bienvenue, ${user.name} !`);
      navigate('/admin/pro');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Email ou mot de passe incorrect');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#E63946] mx-auto flex items-center justify-center mb-4">
            <Car size={36} weight="bold" className="text-white" />
          </div>
          <h1 className="font-['Outfit'] text-2xl font-bold text-gray-900">Espace Professionnel</h1>
          <p className="text-gray-500 mt-2">Connectez-vous à votre espace de gestion</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white border border-gray-200 shadow-sm p-8">
          <div className="space-y-4">
            <div>
              <label className="block text-gray-600 text-sm mb-1">Email</label>
              <input
                type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="votre@email.com"
                className="w-full border border-gray-300 p-3 text-sm focus:border-[#E63946] outline-none"
                data-testid="pro-login-email"
              />
            </div>
            <div>
              <label className="block text-gray-600 text-sm mb-1">Mot de passe</label>
              <input
                type="password" value={password} onChange={e => setPassword(e.target.value)}
                placeholder="Votre mot de passe"
                className="w-full border border-gray-300 p-3 text-sm focus:border-[#E63946] outline-none"
                data-testid="pro-login-password"
              />
            </div>
          </div>
          <button
            type="submit" disabled={loading}
            className="w-full mt-6 py-4 bg-[#E63946] text-white text-sm font-bold uppercase tracking-wide hover:bg-[#D90429] transition-colors flex items-center justify-center gap-2 disabled:bg-gray-400"
            data-testid="pro-login-submit"
          >
            {loading ? <CircleNotch size={20} className="animate-spin" /> : <SignIn size={20} weight="bold" />}
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ProLogin;
